module.exports = "../dist/frontend/icons/logo/blue.svg?7296191879dec1980d3d1b6c34c48762";